// isNumberDot4.js
export default (val) => {
  const pattern = /^\d+(\.?)(\d{1,4})?$/g // 숫자와 . 만 허용. 소숫점 4자리까지 제한
  const pattern2 = /^0\d$/g
  return !pattern.test(val) ||
    (val.length === 2 && val === '00') || // 추가 1: 00 으로 시작되지 못하게 막는다.
    (val.length && pattern2.test(val)) // 추가 2: 0(\d) 01, 03 으로 시작되지 못하게 막는다.
}
